import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class RefreshTokenResponse {
  @jsonMember readonly token!: string;
  @jsonMember readonly refreshToken!: string;
}
